// removed by extract-text-webpack-plugin
module.exports = {"ChatBubbleImage":"ChatBubbleImage__1vF8S","ChatBubbleBackground":"ChatBubbleBackground__MoAJS","tmpComponent":"tmpComponent__6ZFcl","UnreadEntriesCount":"UnreadEntriesCount__3wokA"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBubble/style.scss
// module id = w3l4
// module chunks = 0